export const phoneMask = { name: 'phone', parse: '(999) 999-9999' };
export const zipFullMask = { name: 'zipFull', parse: '00000-0000' };
export const zipMask = { name: 'zip', parse: '00000' };
